module.exports = {"361128001":"饶州街道","361128100":"鄱阳镇","361128101":"谢家滩镇","361128102":"石门街镇","361128103":"四十里街镇","361128104":"油墩街镇","361128105":"田畈街镇","361128106":"金盘岭镇","361128107":"高家岭镇","361128108":"凰岗镇","361128109":"双港镇","361128110":"古县渡镇","361128111":"饶丰镇","361128112":"乐丰镇","361128113":"饶埠镇","361128201":"侯家岗乡","361128202":"莲花山乡","361128203":"响水滩乡","361128206":"枧田街乡","361128207":"柘港乡","361128208":"鸦鹊湖乡","361128209":"银宝湖乡","361128210":"游城乡","361128211":"珠湖乡","361128212":"白沙洲乡","361128213":"团林乡","361128215":"昌洲乡","361128216":"三庙前乡","361128217":"莲湖乡","361128218":"芦田乡","361128401":"农科所","361128402":"饶州监狱"}


//////////////////
// WEBPACK FOOTER
// ./src/town/361128.json
// module id = 1462
// module chunks = 0